// src/hooks/useCategories.ts
import { useEffect, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { clearCategories, fetchCategories } from "src/store/slices/categorySlice";
import { normalizeRole } from "src/constants/roles";

export const useCategories = () => {
  const dispatch = useAppDispatch();
  const {
    items,
    loading,
    error,
    loadedForUserId,
    requestedForUserId,
    failedForUserId,
  } = useAppSelector((state) => state.categories);
  const selectedClient = useAppSelector((state) => state.selectedClient.client);
  const authUser = useAppSelector((state) => state.auth.user);
  const userRole = authUser?.type ? normalizeRole(authUser.type) : null;
  const isAccountant = userRole === "accountant";

  const userId = isAccountant ? selectedClient?.id : authUser?.id;

  const refreshCategories = useCallback(() => {
    console.log("Обновляем категории...");
    if (userId) {
      dispatch(fetchCategories({ user_id: userId }));
    }
  }, [dispatch, userId]);

  useEffect(() => {
    if (!userId) {
      dispatch(clearCategories());
      return;
    }

    if (
      loadedForUserId !== userId &&
      requestedForUserId !== userId &&
      failedForUserId !== userId
    ) {
      dispatch(fetchCategories({ user_id: userId }));
    }
  }, [dispatch, failedForUserId, loadedForUserId, requestedForUserId, userId]);

  return {
    categories: userId && loadedForUserId === userId ? items : [],
    loading: Boolean(userId) && loading,
    error: userId && failedForUserId === userId ? error : null,
    refreshCategories,
  };
};
